import { HTTP_TOKEN_REPORT } from "./http";

export const getLeadsReport = (params) => {
  return HTTP_TOKEN_REPORT.get("report-leads", { params }).then((result) => {
    return result.data;
  });
};
